import * as React from 'react';

import { ViewMedium, Viewport } from 'bernie-view';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { IntentMedia } from './internals/intent-media';
import { MesoTrigger } from './meso-trigger';

interface MesoIntentMediaExpProps {
  pageName: string;
  searchCriteria: SearchCriteriaModel;
}

export const MesoIntentMediaExp: React.FunctionComponent<MesoIntentMediaExpProps> = ({ pageName, searchCriteria }) => (
  <Viewport>
    <ViewMedium>
      <React.Fragment>
        <IntentMedia searchCriteria={searchCriteria} />
        <MesoTrigger pageName={pageName} />
      </React.Fragment>
    </ViewMedium>
  </Viewport>
);
